const midiFolders = [
    'anthems',
    'blues',
    'classical',
    'contemporary',
    'games',
    'gospel',
    'jazz',
    'movies',
    'misc'
];

export default midiFolders;



// WEBPACK FOOTER //
// ./client/components/common/midiFolders.js